var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "18 15 12 9 6 15"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1496 270",
    id: "players-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1496 6.3c-194.1 93.7-427.6 160.3-645.2 183.2L993.8 46C884.6 66.3 806.4 69.9 691.4 69.9c-66.4 0-129.7-3.4-192-10.1s-123.6-16.9-186-30.3L342.7 0H0v67.3c68.3 26.5 138.4 49.4 208.5 67.5l-85.1 85.5C184.5 240 249.3 256.5 316 270h1180V6.3z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    viewBox: "0 0 131.1 166.7",
    id: "pl-logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8,18.8c6.8,3.2,11.3,7.1,12.1,7.7c-0.3-1.8-1.7-10.3-2.6-15.5c3.9,2.7,13.3,9.2,16.3,11.3                 C55.8,18.5,60.2,6,60.2,6s7.8,12.5,9,14.6C70.9,19,80.1,8.6,82.5,6c0.5,5.9,0.9,14.5,1.1,15.7c0.5-0.6,4.1-5.6,10-10.3                 c-2.6,5.1-3.8,12.1-4.4,17.8c-5.9-1.7-12.1-2.6-18.4-2.6c-12.2,0-23.8,3.2-33.8,8.9C35.3,30,32.6,23.2,28.8,18.8z M122.6,126.2                 l-5.4-6c-1.5,16.1-9.5,29.9-24,39.5l-2.3-8.7c-12.4,8.9-33.5,14.6-51.7,4.4c2.3-11.5,4.2-23.2,0-37.2c-10.1,15.5-19,21.7-19,21.7                 c-6.8-11.5-6.2-34.4-4.2-41.2l-11.3,3.5c0-7.7,5.6-24,13.6-33.2l-6.9-1.1c4.8-9.8,11.9-18.2,20.8-24.7c-2.7,4.4-2.7,14.6,5,18.5                 c-3.3-5.7-3.6-12.8-0.3-16.6c3.5-3.8,9.2-2.4,12.8,0.5c-1.1-3.2-4.4-7.2-9-7.5c9-4.7,19.5-7.2,30.3-7.2c2.1,0,4.1,0.2,6,0.3                 c3.2,1.2,7.8,5.7,10,8.6c0,0,0.2-3.3-1.7-7.2c11.8,2.9,17.5,7.7,19.8,10c0.5,5.1,2,8.1,4.1,13c-3.8-4.2-13.4-11.2-18.1-12.8                 c0,0-0.5,4.4-2,6.5c-9.2-6.6-13.6-8.3-13.6-8.3C65.3,42,59,46,55.4,49l3,2.6c-6,1.8-10,7.1-10,7.1c0,0.2,5.4,0.9,5.4,0.9                 s-0.6,6.3,7.4,10.3c6.8,3.3,16.4-0.8,25.6,2.9c-6-6.9-10.1-10.1-10.1-10.1s-2.4-0.5-4.1-0.5c-2.1,0-5.3,0.5-8.6-0.9                 c-1.7-0.6-3.6-1.8-5-2.7c0,0,4.2-4.4,10.4-5.3c0,0,5.6,1.5,10,4.8c2.9-2.9,6-2.7,6-2.7s-3,2.9-2.1,6.2c4.4,3.9,9.2,9.5,9.2,9.5                 c4.8-2.7,15.4-2.1,17.6,0.5c-2.7-3.6-6.8-6.5-9.8-9c-0.3-1.4-3.8-6-4.2-6.5c0,0,3.2,1.1,6,3.5c0.8-1.2,2.4-2.4,4.4-2.9                 c2.1,1.8,2.6,4.5,2.4,5c-0.9,1.2-2,1.7-2,1.7l5.1,5.6l0.5-4.1C124.4,81.8,130.9,101.5,122.6,126.2z M100.2,89.7v-8.7                 c0,0-3.9-1.2-8.1-4.5c-8.4,1.2-18.5,9.7-18.5,9.7s3.5,6.5,7.2,13.6C87.4,100.5,97.2,92.3,100.2,89.7z M108.6,105.5                 c0,0-0.6-3.6-3.6-6.9l-6.5,0.2c0,0-8.9,7.5-14.2,7.7c0,0,3,5.6,4.5,8.4c3-0.6,8.1-3,10.3-5.4c0,0,1.4,4.5,1.1,9.8                 C103.2,117.4,107.3,112.8,108.6,105.5z M111.3,76.7c-3.3,2.7-6,4.4-6,4.4v8.7c2.4,2.6,4.7,4.8,6.5,8.7                 C115.1,92.7,114.3,84,111.3,76.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.f23c8442d45b16e5d112e87d971aa4bc.svg";
export { ForwardRef as ReactComponent };